<script lang="ts">
	// @ts-nocheck
	import slugify from 'slugify';
	import { cn } from '$lib/utils.js';
	import { File, ArrowRight, ChevronDown } from 'lucide-svelte/icons';
	import * as Popover from '$lib/components/ui/popover';
	import { tours } from '$lib/utils/tours';
	import { enhancedImages } from '$lib/utils/images';
	import Button from '../ui/button/button.svelte';
	import Links from './Links.svelte';

	let dayTours = $derived(tours.filter((tour) => tour.productType === 'DAYTOUR'));
	let multiDayTours = $derived(
		tours.filter((tour) => tour.productType === 'MULTIDAYTOUR').reverse()
	);
	let shoreExcursions = $derived(tours.filter((tour) => tour.productType === 'SHOREEXCURSION'));
</script>

<nav class="flex items-center gap-6 text-sm">
	<Popover.Root>
		<Popover.Trigger class={cn('flex items-center transition-colors hover:text-foreground/80')}>
			Day tours <ChevronDown class=" mt-1 h-4 w-4" />
		</Popover.Trigger>

		<Popover.Content
			class="flex w-[1250px] flex-col overflow-hidden rounded-xl p-0"
			align="start"
			sideOffset={24}
		>
			<div class="flex w-full items-center gap-12 bg-secondary">
				<div class="flex flex-col rounded-xl p-6">
					<h2
						class="scroll-m-20 pb-1 font-heading text-xl font-semibold tracking-tight transition-colors first:mt-0"
					>
						Day Tours
					</h2>
					<!-- <div class="mb-4 h-1 w-10 rounded-full bg-tt-red"></div> -->
					<p class="max-w-3xl text-sm">
						Get the best deals on Hobart Tours here! See Australia's best kept secret and hear the
						many stories that have made this island so very desirable. If you're on the lookout for
						day tours from Hobart, Tassie Tours offers a range of exciting discounted day tours in
						Tasmania to choose from.
					</p>
				</div>
			</div>
			<div class="grid grid-cols-6 gap-4 px-4 pt-6">
				{#each dayTours.slice(0, 6) as tour}
					<Popover.Close>
						<a
							data-sveltekit-noscroll
							href={`/tours/${slugify(tour.name, { lower: true })}`}
							data-sveltekit-prefetch
							class="group relative flex aspect-video w-full items-center justify-center overflow-hidden bg-gray-900 px-4 py-20 shadow-xl sm:rounded-xl"
						>
							{#if tour.images && tour.images.length > 0}
								<enhanced:img
									alt={tour.name}
									class="absolute inset-0 h-full w-full object-cover"
									src={Object.entries(enhancedImages).find(
										([key, value]) => key === tour.images[0].itemUrl
									)[1].default}
									sizes="(min-width: 1280px) 16vw, 50vw"
									loading="lazy"
								/>
							{:else}
								<File class="h-48 w-full object-cover text-muted-foreground" />
							{/if}
							<div
								class="absolute inset-0 bg-foreground/40 mix-blend-multiply transition-all group-hover:bg-foreground/50"
							></div>

							<div class="relative mx-auto lg:mx-0">
								<h3 class="text-md text-center font-bold text-background">{tour.name}</h3>
							</div>
						</a>
					</Popover.Close>
				{/each}
			</div>
			<div class="flex rounded-xl px-6 pb-2">
				<Popover.Close>
					<Button
						href="/tours#dayTours"
						variant="link"
						class="pl-0 text-sm font-semibold text-foreground"
					>
						View more <ArrowRight class="ml-2 h-4 w-4" />
					</Button>
				</Popover.Close>
			</div></Popover.Content
		>
	</Popover.Root>
	<Popover.Root>
		<Popover.Trigger class="flex items-center transition-colors hover:text-foreground/80">
			Multi-day tours <ChevronDown class=" mt-1 h-4 w-4" />
		</Popover.Trigger>

		<Popover.Content
			class="flex w-[1250px] flex-col overflow-hidden rounded-xl p-0"
			align="start"
			sideOffset={24}
		>
			<div class="w-full bg-secondary">
				<div class="flex flex-col rounded-xl p-6">
					<h2
						class="scroll-m-20 pb-1 font-heading text-xl font-semibold tracking-tight transition-colors first:mt-0"
					>
						Multi-day Tours
					</h2>
					<!-- <div class="mb-4 h-1 w-10 rounded-full bg-tt-red"></div> -->
					<p class="max-w-xl text-sm">
						It's not only easier but your travelling with a award winning tour company who prides
						itself on professionalism, fun and consistency. It will also give you a chance to meet
						more of the Tassie Tours team who will all share their unique Tasmanian story.
					</p>
				</div>
			</div>
			<div class="grid grid-cols-6 gap-4 px-4 pt-6">
				{#each multiDayTours.slice(0, 6) as tour}
					<Popover.Close>
						<a
							data-sveltekit-noscroll
							href={`/tours/${slugify(tour.name, { lower: true })}`}
							data-sveltekit-prefetch
							class="group relative flex aspect-video w-full items-center justify-center overflow-hidden bg-gray-900 px-4 py-20 shadow-xl sm:rounded-xl"
						>
							{#if tour.images && tour.images.length > 0}
								<enhanced:img
									alt={tour.name}
									class="absolute inset-0 h-full w-full object-cover"
									src={Object.entries(enhancedImages).find(
										([key, value]) => key === tour.images[0].itemUrl
									)[1].default}
									sizes="(min-width: 1280px) 16vw, 50vw"
									loading="lazy"
								/>
							{:else}
								<File class="h-48 w-full object-cover text-muted-foreground" />
							{/if}
							<div
								class="absolute inset-0 bg-foreground/40 mix-blend-multiply transition-all group-hover:bg-foreground/50"
							></div>

							<div class="relative mx-auto lg:mx-0">
								<h3 class="text-center text-sm font-bold text-background">{tour.name}</h3>
							</div>
						</a>
					</Popover.Close>
				{/each}
			</div>
			<div class="flex rounded-xl px-6 pb-2">
				<Popover.Close>
					<Button
						href="/tours#multiDayTours"
						variant="link"
						class="pl-0 text-sm font-semibold text-foreground"
					>
						View more <ArrowRight class="ml-2 h-4 w-4" />
					</Button>
				</Popover.Close>
			</div></Popover.Content
		>
	</Popover.Root>
	<Popover.Root>
		<Popover.Trigger class="flex items-center transition-colors hover:text-foreground/80">
			Private tours <ChevronDown class=" mt-1 h-4 w-4" />
		</Popover.Trigger>

		<Popover.Content
			class="flex w-[1250px] flex-col overflow-hidden rounded-xl p-0"
			align="start"
			sideOffset={24}
		>
			<div class="w-full bg-secondary">
				<div class="flex flex-col rounded-xl p-6">
					<h2
						class="scroll-m-20 pb-1 font-heading text-xl font-semibold tracking-tight transition-colors first:mt-0"
					>
						Private Tours
					</h2>
					<div class="grid grid-cols-2 gap-4">
						<p class=" text-sm">
							Whether you're an adventurous solo traveller or part of a small to medium-sized group,
							our private tour packages are the ultimate way to discover the wonders of Tasmania.
							Let us take care of all the details while you immerse yourself in the beauty and charm
							of this incredible island.
						</p>
						<p class=" text-sm">
							Experience the ultimate Tasmanian adventure with Tassie Tours, where your dream
							holiday becomes a reality. Whether you're seeking a one-day escapade or a multi-day
							exploration, we specialise in tailoring unforgettable experiences to suit your unique
							desires.
						</p>
					</div>
					<!-- <div class="mb-4 h-1 w-10 rounded-full bg-tt-red"></div> -->
				</div>
			</div>
			<div class="grid grid-cols-6 gap-4 px-4 pb-4 pt-6">
				<Popover.Close class="col-span-3">
					<a
						data-sveltekit-noscroll
						href="/private-tours"
						data-sveltekit-prefetch
						class="group relative flex aspect-video h-[160px] w-48 w-full items-center justify-center overflow-hidden bg-gray-900 px-4 py-20 shadow-xl sm:rounded-xl"
					>
						<enhanced:img
							loading="eager"
							alt="Private tours"
							class="absolute inset-0 h-full w-full object-cover"
							src="$lib/assets/images/private-tours-1.jpg"
						/>

						<div
							class="absolute inset-0 bg-foreground/40 mix-blend-multiply transition-all group-hover:bg-foreground/50"
						></div>

						<div class="relative mx-auto lg:mx-0">
							<h3 class="text-center text-xl font-bold text-background">Private Multi-day Tours</h3>
						</div>
					</a>
				</Popover.Close>
				<Popover.Close class="col-span-3">
					<a
						data-sveltekit-noscroll
						href="/custom-private-tours"
						data-sveltekit-prefetch
						class="group relative flex aspect-video h-[160px] w-48 w-full items-center justify-center overflow-hidden bg-gray-900 px-4 py-20 shadow-xl sm:rounded-xl"
					>
						<enhanced:img
							loading="eager"
							alt="Custom Private tours"
							class="absolute inset-0 h-full w-full object-cover"
							src="$lib/assets/images/wineglass.jpg"
						/>

						<div
							class="absolute inset-0 bg-foreground/40 mix-blend-multiply transition-all group-hover:bg-foreground/50"
						></div>

						<div class="relative mx-auto lg:mx-0">
							<h3 class="text-center text-xl font-bold text-background">Custom Private Tours</h3>
						</div>
					</a>
				</Popover.Close>
				<!-- {#each privateTours.slice(0, 6) as tour}
					<Popover.Close>
						<a
							data-sveltekit-noscroll
							href={`/tours/${slugify(tour.name, { lower: true })}`}
							data-sveltekit-prefetch
							class="group relative flex aspect-video w-full items-center justify-center overflow-hidden bg-gray-900 px-4 py-20 shadow-xl sm:rounded-xl"
						>
							{#if tour.images && tour.images.length > 0}
								<enhanced:img
									alt={tour.name}
									class="absolute inset-0 h-full w-full object-cover"
									src={Object.entries(enhancedImages).find(
										([key, value]) => key === tour.images[0].itemUrl
									)[1].default}	src={Object.entries(enhancedImages).find(
										([key]) => key === tour.images[0].itemUrl
									)?.[1]?.default || ''}
									sizes="(min-width: 1280px) 16vw, 50vw"
									loading="lazy"
								/>
							{:else}
								<File class="h-48 w-full object-cover text-muted-foreground" />
							{/if}
							<div
								class="absolute inset-0 bg-foreground/40 mix-blend-multiply transition-all group-hover:bg-foreground/50"
							></div>

							<div class="relative mx-auto lg:mx-0">
								<h3 class="text-center text-sm font-bold text-background">
									{tour.name.split('-')[1]}
								</h3>
							</div>
						</a>
					</Popover.Close>
				{/each} -->
			</div>
			<!-- <div class="flex rounded-xl px-6 pb-2">
				<Popover.Close>
					<Button
						href="/private-tours"
						variant="link"
						class="pl-0 text-sm font-semibold text-foreground"
					>
						Learn more <ArrowRight class="ml-2 h-4 w-4" />
					</Button>
				</Popover.Close>
				<Popover.Close>
					<Button
						href="/custom-private-tours"
						variant="link"
						class="pl-0 text-sm font-semibold text-foreground"
					>
						Custom private tours <ArrowRight class="ml-2 h-4 w-4" />
					</Button>
				</Popover.Close>
			</div> -->
		</Popover.Content>
	</Popover.Root>
	<Popover.Root>
		<Popover.Trigger class="flex items-center transition-colors hover:text-foreground/80">
			Shore excursions <ChevronDown class=" mt-1 h-4 w-4" />
		</Popover.Trigger>

		<Popover.Content
			class="flex w-[1250px] flex-col overflow-hidden rounded-xl p-0"
			align="start"
			sideOffset={24}
		>
			<div class="w-full bg-secondary">
				<div class="flex flex-col rounded-xl p-6">
					<h2
						class="scroll-m-20 pb-1 font-heading text-xl font-semibold tracking-tight transition-colors first:mt-0"
					>
						Shore Excursions
					</h2>
					<!-- <div class="mb-4 h-1 w-10 rounded-full bg-tt-red"></div> -->
					<p class="max-w-xl text-sm">
						Coming to Tasmania via Cruise ship and want to maximise your time while you are on dry
						land? We offer tours state wide to all the major tourist attractions at an affordable,
						fair price. We are a professional team who love show casing Tasmania to people from all
						around the world.
					</p>
				</div>
			</div>
			<div class="grid grid-cols-6 gap-4 px-4 pt-6">
				{#each shoreExcursions.slice(0, 6) as tour}
					<Popover.Close>
						<a
							data-sveltekit-noscroll
							href={`/tours/${slugify(tour.name, { lower: true })}`}
							data-sveltekit-prefetch
							class="group relative flex aspect-video w-full items-center justify-center overflow-hidden bg-gray-900 px-4 py-20 shadow-xl sm:rounded-xl"
						>
							{#if tour.images && tour.images.length > 0}
								<enhanced:img
									alt={tour.name}
									class="absolute inset-0 h-full w-full object-cover"
									src={Object.entries(enhancedImages).find(
										([key, value]) => key === tour.images[0].itemUrl
									)[1].default}
									sizes="(min-width: 1280px) 16vw, 50vw"
									loading="lazy"
								/>
							{:else}
								<File class="h-48 w-full object-cover text-muted-foreground" />
							{/if}
							<div
								class="absolute inset-0 bg-foreground/40 mix-blend-multiply transition-all group-hover:bg-foreground/50"
							></div>

							<div class="relative mx-auto lg:mx-0">
								<h3 class="text-md text-center font-bold text-background">{tour.name}</h3>
							</div>
						</a>
					</Popover.Close>
				{/each}
			</div>
			<div class="flex rounded-xl px-6 pb-2">
				<Popover.Close>
					<Button
						href="/tours#shoreExcursions"
						variant="link"
						class="pl-0 text-sm font-semibold text-foreground"
					>
						View more <ArrowRight class="ml-2 h-4 w-4" />
					</Button>
				</Popover.Close>
			</div></Popover.Content
		>
	</Popover.Root>
	<Links />

	<a data-sveltekit-noscroll href="/blog" class="transition-colors hover:text-foreground/80">
		Blog
	</a>
	<!-- <a data-sveltekit-noscroll href="/contact" class="transition-colors hover:text-foreground/80">
		Contact
	</a> -->
</nav>
